

























































import Vue from 'vue'
import Component from 'vue-class-component'

import { IJobPosting } from '@app/componentlib/common/types/JobSearchTypes'
import { niceDate } from '@app/componentlib/src/application/helpers/timeHelpers'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import JobDetailsViewDebugInfo from './JobDetailsViewDebugInfo.vue'
import HeartEmptyFull from '../HeartEmptyFull.vue'
import { JobMatchModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatch'
import { IResultPage } from '@app/componentlib/common/types/JobMatchTypes'

@Component<JobDetailsView>({
  components: {
    JobDetailsViewDebugInfo,
    HeartEmptyFull
  },
  props: {
    selectedJobPosting: Object,
    useSavedAdvert: Boolean,
    jobmatch: Boolean,
    content: Object,
    jobApplicationAccess: Boolean
  },
  watch: {
    selectedJobPosting: {
      handler () {
        this.scrollToTop()
      }
    }
  },
})

export default class JobDetailsView extends Vue {
  /**
   * Props variables
   */
  selectedJobPosting: IJobPosting | undefined
  windowHeight = window.innerHeight
  useSavedAdvert: boolean | undefined
  jobmatch: boolean = false
  content: IResultPage | undefined
  jobApplicationAccess: boolean | undefined

  /**
   * Component state variables
   */

  /**
   * Lifecycle
   */

  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get isMobile (): boolean {
    return AppModule.isMobile
  }

  /**
   * Methods
   */
  goToPage (url?: string): void {
    if (url !== null && url !== "") {
      window.open(url, '_blank', 'noopener,noreferrer')?.focus()
    }
  }

  formatDate (date: Date) {
    return niceDate(date)
  }

  closeDetailView () {
    this.$emit('setSelectedJobPosting', undefined)
  }

  toggleSavedAdvert (posting: IJobPosting) {
    this.$emit('toggleSavedAdvert', posting)
  }

  formatUrlString (url: string) {
    if (url !== "" && url !== undefined) {
      let tempString = url
      tempString = tempString.replace("https://", "")
      tempString = tempString.replace("http://", "")
      tempString = tempString.replace("www.", "")

      let splitString = tempString.split("/")
      let splitString2 = splitString[0].split(".")

      return splitString2[splitString2.length - 2] + "." + splitString2[splitString2.length - 1]
    }
    else {
      return ""
    }
  }

  scrollToTop () {
    const jobDetailsView = document.querySelector('.job-details-view') as Element
    if (jobDetailsView) {
      jobDetailsView.scrollTop = 0
    }
  }

  goToJobApplication (jobId?: string) {
    if (this.content && jobId !== undefined) {
      const req = {
        url: this.content.navigateToJobApplication,
        jobId: jobId
      }
      JobMatchModule.navigateToJobApplication(req)
    }
  }
}
